import { useDispatch, useSelector } from 'react-redux'
import { Link } from "react-router-dom"
import { toast } from "react-toastify"

import { logoutWithJWT } from "../../app/api/apiSlice"

import "./scss/main.scss"

const Header = (props) => {
  
  const dispatch = useDispatch()
  
  const user = useSelector(state => state.api.user)
  
  const handleSubmitLogout = (e) => {
    e.preventDefault()
    dispatch(
      logoutWithJWT()
    )
    toast.success('Vous êtes déconnecté')
  }

  const Greatings = () => (
    !user
    ? null
    : (
      <div id="logout" className="navbar-text">
        <img src="/images/icon-logged-user.png" alt="DropCV" />
        <span>Bonjour {`${user?.firstName || ""} ${user?.lastName || ""}`}</span>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" onClick={ e => handleSubmitLogout(e) }>Se déconnecter</a>
      </div>
    )
  )

  const MenuMyAccount = () => (
    !user
    ? null
    : (
      <li className="nav-item dropdown">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a className="nav-link dropdown-toggle" id="dropdown01" data-bs-toggle="dropdown" aria-expanded="false">Mon compte</a>
        <ul className="dropdown-menu" aria-labelledby="dropdown01">
          {
            (user.role & parseInt(2))
            ? (
              <>
                <li><Link to="/cvInvites" className="dropdown-item">CV invités</Link></li>
                <li><Link to="/favoris" className="dropdown-item">Mes CV favoris</Link></li>
                <li><Link to="/annonces" className="dropdown-item">Mes annonces</Link></li>
              </>
            )
            : (
              <>
                <li><Link to="/modifierMonCv" className="dropdown-item">Modifier ou voir mon CV</Link></li>
              </>
            )
          }
          <li><Link to="/editerCompte" className="dropdown-item">Modifier mes informations</Link></li>
        </ul>
      </li>
    )
  )

  const MenuItemMyAccount = () => (
    user && (user.role & parseInt(2))
    ? (
      <li className="nav-item">
        <Link to="/chercherCV" className="nav-link" title="Chercher un candidat">Chercher des CV</Link>
      </li>
    )
    : null
  )

  return (
    <div id="nav-container">
      <nav className="navbar navbar-expand-md navbar-light container-md">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand"><img src="/images/dropcv-logo.png" alt="DropCV" /></Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <Greatings />
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="nav navbar-nav me-auto mb-2 mb-md-0">
              <MenuMyAccount />
              <MenuItemMyAccount />
              <li className="nav-item">
                <Link to="/contact" className="nav-link" title="Nous contacter">Contact</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Header